import axios from 'axios';

export const decodeHexMessage = (message) =>
  message.replace(/\\u(\w{4})/g, (a, hex) => String.fromCharCode(parseInt(hex, 16)));

export const decodeHexMessages = (messages) =>
  Object.assign(
    {},
    ...Object.keys(messages).map((key) => ({
      [key]: decodeHexMessage(messages[key] || ''),
    }))
  );

export const getI18N = async (url, callback) => {
  let messagesJson;

  if (!url) {
    return;
  }

  try {
    const result = await axios(url);

    messagesJson = result.data;
  } catch {
    messagesJson = {};
  }

  if (typeof messagesJson === 'string') {
    messagesJson = {};
    console.error('i18n json format error.');
  }

  callback(decodeHexMessages(messagesJson));
};


export const i18nify = (
  messages,
  key,
  ...placeholders
) => {
  if (typeof key === 'undefined') {
      return ''
  }

  const message = (typeof key === 'string' && messages && messages[key.trim()]) || String(key)
  const _placeholders = typeof placeholders[0] === 'object' ? placeholders[0] : placeholders

  return message.replace(/\{([^}]+)\}/g, (a, b) => i18nify(messages, _placeholders[b.trim()]))
}
